import {
  DialogContent,
  Dialog,
  DialogProps,
  DialogActions,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';
import { PmiButton } from 'shell/components/shared/button';
import { styled } from '@mui/styles';
import { memo } from 'react';
import { noop } from 'shell/utils/noop';
import ContentInitiative from './content-initiative';
import ContetTemporary from './content-temporary';
import { TypeInitiative } from 'practice/constants/practice-management-step';

export const PmiDialog = styled((props: DialogProps) => <Dialog {...props} />)((props) => ({
  '& .MuiDialog-paper': props.fullScreen
    ? {
        minWidth: 'unset',
        maxWidth: '100%',
      }
    : {
        minWidth: '50rem',
        maxWidth: '300px',
      },
}));

interface ModalInitiativeComponentProps {
  open: boolean;
  onChange: (value: TypeInitiative, typePractice?: string) => void;
  onSave: () => void;
  typeSelected?: TypeInitiative;
  ForPracticeTemporary?: boolean;
  typePractice?: string;
}

const ModalInitiativeComponent = ({
  open,
  onSave,
  typeSelected,
  onChange,
  ForPracticeTemporary = false,
  typePractice,
}: ModalInitiativeComponentProps): React.ReactElement => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      fullScreen={fullScreen}
      open={open}
      onClose={noop}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <PmiDialogTitle id="alert-dialog-title" backgroundColor="primary" color="white">
        {ForPracticeTemporary ? 'Tipo pratica:' : 'Iniziativa:'}
      </PmiDialogTitle>
      <DialogContent style={{ padding: '30px 24px' }}>
        {ForPracticeTemporary ? (
          <ContetTemporary typeSelected={typePractice as TypeInitiative} onChange={onChange} />
        ) : (
          <ContentInitiative typeSelected={typeSelected} onChange={onChange} />
        )}
      </DialogContent>
      <DialogActions>
        <PmiButton
          variant="contained"
          color="primary"
          type="submit"
          onClick={onSave}
          disabled={!Boolean(typeSelected)} // quando viene selezionato un valore si abilita
        >
          CONFERMA
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
};

ModalInitiativeComponent.displayName = 'Modal initiative component';

const ModalInitiative = memo(ModalInitiativeComponent);

export default ModalInitiative;
